import "./ourServices.css";

import Imag1 from "./homepage_images/home-images/cashier.jpg";
import Imag2 from "./homepage_images/home-images/cashier.jpg";
import Imag3 from "./homepage_images/home-images/cashier.jpg";
const services = [
  {
    id: 1,
    title: "No accounting degree required.",
    tag: "Easy to use",
    desc: "No weeks of training. Just work.",
    img: Imag1,
  },
  // {
  //   id: 2,
  //   title: "Always know what is in stock.",
  //   tag: "Inventory control",
  //   desc: "Keep products, quantities, and stock movements organized.",
  //   img: Imag1,
  // },
  {
    id: 3,
    title: "Built for your entire team.",
    tag: "Team access",
    desc: "Let the right people manage the right parts of your business.",
    img: Imag1,
  },
  {
    id: 4,
    title: "Your business, at a glance.",
    tag: "Analytics",
    desc: "Understand sales, stock, and performance without digging through records.",
    img: Imag1,
  },
  {
    id: 5,
    title: "Know before stock runs out.",
    tag: "Stock alerts",
    desc: "Stay ahead of low and exhausted items before they affect sales.",
    img: Imag1,
  },
  {
    id: 6,
    title: "Turn your counter into a checkout.",
    tag: "Point of sale",
    desc: "Scan products, process sales, and update inventory in real time.",
    img: Imag1,
  },
  {
    id: 7,
    title: "One system. Every location.",
    tag: "Multi-location",
    desc: "Manage branches, warehouses, and inventory from one place.",
    img: Imag1,
  },
  // {
  //   id: 8,
  //   title: "Scan it. Find it. Done.",
  //   tag: "Barcode & QR",
  //   desc: "Use barcodes and QR codes to identify products faster and more accurately.",
  //   img: Imag1,
  // },
];

export default function OurServices() {
  return (
    <section className="sectionOurServices fx-cl space6">
      <div className="ourSrvc g g3 space2 fs1">
        {services.map((service) => (
          <figure key={service.id} className="fx-ac spacem">
            <img src={service.img} alt={service.title} />
            <div className="fx-cl spacem">
              <div className="fx-ac fx-jb space2">
                <h3>{service.title}</h3>
                <span className="srvcTag">{service.tag}</span>
              </div>
              <p>
                {/* {service.desc.length > 30
                  ? service.desc.slice(0, 100) + "..."
                  : service.desc} */}
                {service.desc}
              </p>
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
}
